import script from "./FelipeWinsAFOSRGrant.vue?vue&type=script&setup=true&lang=js"
export * from "./FelipeWinsAFOSRGrant.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__